<template>
    <div ref="list" class="tw-space-y-5">
        <div
            v-for="notification in notifications.slice(0, maxAmountVisible)"
            :key="notification._id"
            class="tw-flex tw-space-x-6 tw-items-center tw-justify-center tw-group"
            data-test-class="notification-item"
        >
            <a
                :href="`#/profile/${(returnRelevantUserDetails(notification) || {})._id}`"
                class="tw-flex-grow-0 tw-p-2"
            >
                <l-profile-picture size="xm" :user="returnRelevantUserDetails(notification)" />
            </a>

            <div class="tw-flex-1">
                <a
                    class="tw-block tw-text-gray-900 hover:tw-text-indigo-500 focus:tw-text-indigo-500 tw-line-clamp-1"
                    :href="notification.template.link"
                >
                    <template v-if="isSenderCurrentUser(notification)">
                        {{ notification.template.titleMirror }}
                    </template>
                    <template v-else>
                        {{ notification.template.title }}
                    </template>
                </a>

                <div class="tw-line-clamp-1">
                    <span
                        v-if="notification.template.deadline"
                        v-b-popover.hover.top="'Deadline'"
                        class="tw-text-gray-500 tw-mr-2"
                    >
                        <i class="fal fa-alarm-clock tw-mr-2"></i>
                        {{ notification.template.deadline }}
                    </span>

                    <span
                        v-if="notification.template.subtitle"
                        v-b-popover.hover.bottom="
                            notification.template.subtitle.length > 60
                                ? notification.template.subtitle
                                : ''
                        "
                        class="tw-text-gray-500"
                    >
                        <i class="fal fa-info-circle tw-mr-2"></i>
                        {{ notification.template.subtitle }}
                    </span>

                    <span
                        v-if="!notification.template.subtitle && showNotificationCreationTime"
                        class="tw-text-gray-500"
                    >
                        {{ notification.createdRelative }}
                    </span>
                </div>
            </div>

            <div
                v-if="user.impersonated || (!isVisitor && notification.template.dismissable)"
                class="tw-flex-grow-0 tw-hidden lg:tw-block"
            >
                <l-base-button
                    v-b-popover.hover.top="$t('profile.notif.btnDismiss')"
                    :button-types="['secondary', 'framed']"
                    class="tw-hidden group-hover:tw-inline-block tw-px-3"
                    data-test-class="notification-dismiss"
                    @click.native="onDismiss(notification._id)"
                    >X</l-base-button
                >
            </div>
            <div
                v-if="notification.accessingUserToDo && !isVisitor"
                class="tw-flex-grow-0 tw-hidden lg:tw-block"
            >
                <l-base-button
                    :href="notification.template.link"
                    :button-types="['primary', 'raised']"
                    data-test-class="notification-action-link"
                    >{{ $t("profile.notif.labelToDo") }}</l-base-button
                >
            </div>
        </div>

        <l-user-profile-load-more
            :items="notifications"
            :value.sync="maxAmountVisible"
            :max-amount-visible="maxAmountVisibleDefault"
            :scroll-to-element="$refs.list"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LProfilePicture from "@/components/LProfilePicture";
import LUserProfileLoadMore from "@/components/LUserProfile/LUserProfileLoadMore";
import LBaseButton from "@/components/LBaseButton";

export default {
    components: {
        LProfilePicture,
        LUserProfileLoadMore,
        LBaseButton,
    },
    props: {
        notifications: {
            type: Array,
            default: () => [],
        },
        isVisitor: {
            type: Boolean,
            default: true,
        },
        maxAmountVisibleDefault: {
            type: Number,
            default: 3,
        },
        showNotificationCreationTime: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            maxAmountVisible: this.maxAmountVisibleDefault,
        };
    },
    computed: {
        ...mapGetters({
            user: "users/current/user",
        }),
    },
    methods: {
        isSenderCurrentUser(notification = {}) {
            return notification.sender?.user?._id === this.user._id;
        },
        returnRelevantUserDetails(notification = {}) {
            if (
                notification.sender?.user?._id !== this.user._id &&
                notification.sender?.user?._id
            ) {
                return notification.sender.user;
            } else if (
                notification.sender?.user?._id === this.user._id ||
                !notification.sender?.user?._id
            ) {
                return notification.receiver.user;
            }
        },
        onDismiss(notificationId) {
            this.$store.dispatch("notifications/profilePreview/dismissNotification", {
                payload: { notificationId },
            });
        },
    },
};
</script>

<style scoped>
/* bootstrap override */
.btn.tw-px-3 {
    padding-left: 10px;
    padding-right: 10px;
}
</style>
